// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1CnlG","newExpiryDate":"styles_newExpiryDate__GuI6a","footer":"styles_footer__G9je9"};